export const DEFAULT_PAGE_SIZE = 10;
export const VIDEOS_PAGE_SIZE = 12;

export interface PaginationMeta {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
}

export interface PaginatedList<T> {
  records: T[];
  meta: PaginationMeta;
}

export const EMPTY_PAGINATION_META: PaginationMeta = {
  pageNumber: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  totalRecords: 0,
  totalPages: 0,
};

export function buildListQuery(
  pageNumber: number,
  pageSize: number,
  params?: Record<string, string | number | boolean | undefined | null>,
): string {
  const search = new URLSearchParams({
    pageNumber: String(pageNumber),
    pageSize: String(pageSize),
  });
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value === undefined || value === null || value === "") continue;
      search.set(key, String(value));
    }
  }
  const qs = search.toString();
  return qs ? `?${qs}` : "";
}

export function paginationRange(meta: PaginationMeta): { rangeStart: number; rangeEnd: number } {
  if (meta.totalRecords === 0) {
    return { rangeStart: 0, rangeEnd: 0 };
  }
  return {
    rangeStart: (meta.pageNumber - 1) * meta.pageSize + 1,
    rangeEnd: Math.min(meta.pageNumber * meta.pageSize, meta.totalRecords),
  };
}

export function totalPagesFromMeta(meta: PaginationMeta): number {
  return Math.max(1, meta.totalPages);
}

/**
 * The page numbers to show around `page` — at most `size` of them, clamped so the
 * window never runs off either end. Replaces a fixed 1..size list, which left you
 * looking at buttons 1–5 with none highlighted once you paged past 5.
 */
export function pageWindow(page: number, totalPages: number, size = 5): number[] {
  if (totalPages < 1) return [];
  const count = Math.min(size, totalPages);
  const start = Math.min(Math.max(1, page - Math.floor(count / 2)), totalPages - count + 1);
  return Array.from({ length: count }, (_, i) => start + i);
}
